import { CardButton, CardButtonProps } from '@superdispatch/ui';
import { PermissionAction } from './PermissionAction';
import { PermissionDTO } from '../PermissionDTO';
import { PermissionIcon } from './PermissionIcon';
import { usePermissionAccess } from '../data/usePermissionAccess';

interface PermissionCardButtonProps<
  T extends keyof PermissionDTO,
> extends CardButtonProps {
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
  children: React.ReactNode;
}

export function PermissionCardButton<T extends keyof PermissionDTO>({
  name,
  permission,
  children,
  ...cardButtonProps
}: PermissionCardButtonProps<T>) {
  const hasNoAccess = usePermissionAccess({ name, permission });
  return (
    <PermissionAction name={name} permission={permission}>
      <CardButton
        {...cardButtonProps}
        startIcon={
          hasNoAccess ? (
            <PermissionIcon name={name} permission={permission}>
              <div>{cardButtonProps.startIcon}</div>
            </PermissionIcon>
          ) : (
            cardButtonProps.startIcon
          )
        }
      >
        {children}
      </CardButton>
    </PermissionAction>
  );
}
